import { Alert, DateRange, VFlow } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PageHeaderSection } from 'components/PageHeaderSection'
import { PivotTable } from 'components/pivot-table/PivotTable'
import { useAbsenteismosLazyQuery } from 'graphql/hooks.generated'
import React, { useCallback, useState } from 'react'

import { BiTableWrapper } from '../components/BiTableWrapper'
import { Absenteismo } from './Absenteismo'
import { absenteismoKeyMapping } from './absenteismoKeyMapping'

export function AbsenteismoView(props: any) {
  const [getAbsenteismos, { loading, data }] = useAbsenteismosLazyQuery({
    fetchPolicy: 'cache-first',
  })

  const [dateRangeFilter, setDateRangeFilter] = useState<DateRange>()

  const handleRangeChange = useCallback(
    (dateRange: DateRange) => {
      setDateRangeFilter(dateRange)
      getAbsenteismos({
        variables: {
          input: { dataInicio: dateRange.startDate, dataFim: dateRange.endDate },
        },
      })
    },
    [getAbsenteismos]
  )

  return (
    <>
      <Breadcrumb title='Absenteísmo' />

      <PageHeaderSection title='Relatório de absenteísmo' />

      <PageContent type='filled'>
        <VFlow>
          <Alert inline type='info'>
            O relatório de absenteísmo apresenta a contagem dos agendamentos em que o cidadão não compareceu ou não
            aguardou.
          </Alert>

          <BiTableWrapper
            loading={loading}
            noData={!data?.absenteismos || data?.absenteismos.length === 0}
            handleRangeSelect={handleRangeChange}
          >
            <PivotTable<Absenteismo>
              key={data?.absenteismos.length}
              data={data?.absenteismos}
              keyMapping={absenteismoKeyMapping}
              title='Relatório de absenteísmo'
              dateRangeFilter={dateRangeFilter}
            />
          </BiTableWrapper>
        </VFlow>
      </PageContent>
    </>
  )
}
